import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { TextInput } from 'components';

class FreeTextInput extends Component {
    static propTypes = {
      hasError: PropTypes.bool,
      errorMessage: PropTypes.string,
      id: PropTypes.string,
      isDisabled: PropTypes.bool,
      onComponentUpdate: PropTypes.func,
      placeholder: PropTypes.string,
      value: PropTypes.string,
    }

    static defaultProps = { 
      isDisabled: false,
      hasError: false,
    }

    state = {
      hasError: this.props.hasError || false,
      errorMessage: this.props.errorMessage || "",
      value: this.props.value || "",
    }

    componentDidMount() {
      this.setupState();
    }

    componentDidUpdate(prevProps, prevState) {
      if (this.hasPropsUpdated(prevProps)) {
        this.setupState();
      }
      if (this.hasValueChanged(prevState)){
        if (this.props.onComponentUpdate) {
          this.handleComponentUpdate();
        }
      }
    }

    hasPropsUpdated = (prevProps) => {
      return (
        prevProps.hasError !== this.props.hasError ||
        prevProps.errorMessage !== this.props.errorMessage ||
        prevProps.value !== this.props.value
      );
    }

    hasValueChanged = (prevState) => {
      if (prevState.value !== this.state.value){
        return true;
      }
      return false;
    }

    setupState = () => {
      const { hasError, errorMessage, value } = this.props;

      const newState = {
        ...((hasError !== undefined) && { hasError }),
        ...((errorMessage !== undefined) && { errorMessage }),
        ...((value !== undefined) && { value }),
      };

      this.setState({ ...newState });
    }

    handleComponentUpdate = () => {
      const { hasError, errorMessage, value } = this.state;
      const componentData = { hasError, errorMessage, value };
      this.props.onComponentUpdate(componentData);
    }

    handleInput = (elementEvent) => {
      const eventValue = elementEvent.target.value;
      this.setState({ value: eventValue });
    }

    render() {
      return (
        <TextInput
          disabled={this.props.isDisabled}
          hasError={this.state.hasError}
          messageError={this.state.errorMessage}
          name={this.props.id}
          onInputChange={(elementEvent) => this.handleInput(elementEvent)}
          placeholder={this.props.placeholder}
          type="text"
          value={this.state.value}
        />
      );
    }
}

export default FreeTextInput;